// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleDek_root__3Tnzx","ideasRoot":"ArticleDek_ideasRoot__19m13"};